import { render } from "./Pigeon.vue?vue&type=template&id=43213982"
import script from "./Pigeon.vue?vue&type=script&lang=js"
export * from "./Pigeon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__